import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../common/propTypes';
import { connect } from 'react-redux';
import { getUserPermissionsKeys } from './selectors';

function Authorization({
    accessToCheck,
    permissions,
    onApproval,
    onRejection,
}) {
    return (
        <>
            {permissions.includes(accessToCheck)
                ? onApproval() // user does have the required permission
                : onRejection()}
        </>
    );
}

Authorization.propTypes = {
    /**
     * @property {string} accessToCheck - access key to check against the permission of current user, e.g. pp_dashboard_view
     */
    accessToCheck: PropTypes.string.isRequired,

    /**
     * @property {array[string]} permissions - array containing all the permission keys of the current user
     */
    permissions: PropTypes.array.isRequired,

    /**
     * @property {callback} onApproval - function to be called if the current user has the required permisison
     */
    onApproval: PropTypes.func,

    /**
     * @property {callback} onRejection - function to be called if the current user does not have the required permisison
     */
    onRejection: PropTypes.func,
};

Authorization.defaultProps = {
    onApproval: noop,
    onRejection: noop,
};

const mapStateToProps = (state) => {
    return {
        permissions: getUserPermissionsKeys(state),
    };
};

export default connect(mapStateToProps)(Authorization);
